import { useStaticQuery, graphql } from 'gatsby'

export function useAbout() {
  const {
    allPagesJson: {
      nodes: [about],
    },
  } = useStaticQuery(graphql`
    query About {
      allPagesJson(filter: { id: { eq: "about" } }) {
        nodes {
          appTitle
          appDescription
          z1Title
          z1Description
        }
      }
    }
  `)

  return about
}
